import actions from './usersActions'
import getters from './usersGetters'
import state from './usersState'
import mutations from './usersMutation'

export default {
  namespaced: true,
  actions,
  getters,
  state,
  mutations,
}
